module.exports = __webpack_public_path__ + "static/strafe0-825c48edb28173d7bae057ac47a64627.png";